// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors","mptcfe-pc-player","pc-login","vendors-node_modules_pnpm_clipboard_2_0_11_node_modules_clipboard_dist_clipboard_js-node_modu-8162d4"], () => (__webpack_require__(6493)))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
